import { Sprite } from './types';

export const SMALL_SPRITES: Sprite[] = [
  {
    name: 'Pikachu',
    imageUrl: 'https://mahval-small-sprites.s3.eu-west-1.amazonaws.com/025Pikachu.png',
  },
  {
    name: 'Sandshrew',
    imageUrl: 'https://mahval-small-sprites.s3.eu-west-1.amazonaws.com/027Sandshrew.png',
  },
  {
    imageUrl: 'https://mahval-small-sprites.s3.eu-west-1.amazonaws.com/kos-big-animated.gif',
  },
];
